<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">{{ $t('reports.name') }}</li>
      </ol>
    </nav>

    <div class="container-fluid">

      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">{{ $t('monthlyReports') }}</h1>
          <p class="lead text-muted">
            {{ $t('reports.name') }}
            {{ $t('forProperty') }}
            {{property.name}}
          </p>
        </div>
      </header>

      <div class="mt-4">
        <button type="button" class="btn btn-sm btn-primary mr-2" @click="today" :disabled="date > maxDate">
          {{ $t('today') }}
        </button>
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-sm btn-primary" @click="previous">
            <span class="fc-icon fc-icon-chevron-left"></span>
          </button>
          <button type="button" class="btn btn-sm btn-primary" @click="next" :disabled="date >= maxDate">
            <span class="fc-icon fc-icon-chevron-right"></span>
          </button>
        </div>
      </div>

      <h2 class="mt-4">{{ monthName }} {{year}}</h2>

      <div class="mt-2">
        <button class="btn btn-primary mb-3" @click="$router.push('/' + $i18n.locale + '/' + $route.params.property + '/' + $t('reports.url') + '/' + $t('units.url') + '/' + year + '/' + month)" :disabled="date > maxDate" style="width:230px;">
          {{ $t('units.name') }}
        </button>

        <br>

        <button class="btn btn-primary mb-3" @click="$router.push('/' + $i18n.locale + '/' + $route.params.property + '/' + $t('reports.url') + '/' + $t('invoices.url') + '/' + year + '/' + month)" :disabled="date > maxDate" style="width:230px;">
          {{ $t('invoices.name') }}
        </button>

        <br>

        <button class="btn btn-primary mb-3" @click="$router.push('/' + $i18n.locale + '/' + $route.params.property + '/' + $t('reports.url') + '/' + $t('guests.url') + '/' + year + '/' + month)" :disabled="date > maxDate" style="width:230px;">
          {{ $t('guests.name') }}
        </button>

        <div v-if="month == 1">
          <button class="btn btn-primary mb-3" @click="$router.push('/' + $i18n.locale + '/' + $route.params.property + '/' + $t('reports.url') + '/' + $t('deletion.url') + '/' + deletionYear)" :disabled="date > maxDate" style="width:230px;">
            {{ $t('deletion.name') }}
            {{ deletionYear }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'Reports',
  data: () => ({
    title: '',
    date: '',
    maxDate: moment().subtract(1, 'month').format('YYYY-MM'),
    year: '',
    month:'',
    property: {},
  }),
  computed: {
    monthName: function(){
      if(!this.month) return '';
      return moment(this.month, 'MM').locale(this.$i18n.locale).format('MMMM');
    },
    deletionYear: function(){
      if(!this.year) return;
      return Number(this.year) - 2;
    }
  },
  created(){
    this.date = this.$route.params.year && this.$route.params.month ? this.$route.params.year + '-' + moment(this.$route.params.month, "M").format('MM') : this.maxDate
    const slug = this.$route.params.property;
    this.property = this.$store.state.host.properties.find(p => p.slug == slug);
  },
  methods: {
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    today(){
      this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('reports.url'))
    },
    previous(){
      this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('reports.url') + '/' + moment(this.date, 'YYYY-MM').subtract(1, 'month').format('YYYY') + '/' + moment(this.date, 'YYYY-MM').subtract(1, 'month').format('M'))
    },
    next(){
      this.$router.push('/' + this.$i18n.locale  + '/' + this.property.slug + '/' + this.$t('reports.url') + '/' + moment(this.date, 'YYYY-MM').add(1, 'month').format('YYYY') + '/' + moment(this.date, 'YYYY-MM').add(1, 'month').format('M'))
    }
  },
  watch: {
    $route(){
      this.date = this.$route.params.year && this.$route.params.month ? this.$route.params.year + '-' + moment(this.$route.params.month, "M").format('MM') : this.maxDate
    },
    date(){
      this.year = moment(this.date, 'YYYY-MM').format('YYYY');
      this.month = moment(this.date, 'YYYY-MM').format('M')
    }
  }
};
</script>

<i18n>
{
  "en": {
    "reports": {
      "name": "Reports",
      "url": "reports"
    },
    "monthlyReports": "Monthly Reports",
    "forProperty": "for property",
    "today": "Today",
    "units": {
      "name": "Units Sold",
      "url": "units-sold"
    },
    "invoices": {
      "name": "Issued Invoices",
      "url": "issued-invoices"
    },
    "guests": {
      "name": "Number of Guests",
      "url": "number-of-guests"
    },
    "deletion": {
      "name": "Deletion Report",
      "url": "deletion-report"
    }
  },
  "sl": {
    "reports": {
      "name": "Poročila",
      "url": "porocila"
    },
    "monthlyReports": "Mesečna poročila",
    "forProperty": "nastanitve",
    "today": "danes",
    "units": {
      "name": "Prodane enote",
      "url": "prodane-enote"
    },
    "invoices": {
      "name": "Izdani računi",
      "url": "izdani-racuni"
    },
    "guests": {
      "name": "Število gostov",
      "url": "stevilo-gostov"
    },
    "deletion": {
      "name": "Poročilo o izbrisu",
      "url": "porocila-o-izbrisu"
    }
  }
}
</i18n>
